import * as actions from '../services'
import * as types from './mutations-types'
import { addFlash } from 'src/app/components/shareds/flash/vuex/mutations-types'
import { t } from 'src/utils/form'
import { setPagination } from 'src/app/components/shareds/pagination/vuex/mutations-types'
import csv from 'src/utils/csv'
import date from 'src/utils/date'

export const loadInvoicesByContract = (context, payload) => {
  return actions.getInvoicesByContract(payload)
  .then(function (response) {
    if (response && response.status === 200) {
      context.commit(types.setInvoices, response.data.invoices)
    }
    return response
  })
}

export const paginateInvoices = (context, payload) => {
  return actions.paginateInvoices(payload)
  .then((response) => {
    context.commit(setPagination, response.data.meta)
    context.commit(types.setInvoices, response.data.invoices)
  })
}

export const loadInvoicesByCustomer = (context, payload) => {
  return actions.getInvoicesByCustomer(payload)
  .then(function (response) {
    if (response && response.status === 200) {
      context.commit(types.setInvoices, response.data.invoices)
    }
    return response
  })
}

export const createInvoice = (context, payload) => {
  return actions.newInvoice(payload)
  .then(function (response) {
    if (response && response.status === 201) {
      context.commit(types.setInvoice, response.data.invoice)
      context.commit(addFlash, { message: t(context, 'invoices.alerts.successfully_generated_invoice'), type: 'ls-alert-success' })
    } else {
      context.commit(addFlash, { message: t(context, 'invoices.alerts.generating_invoice_error'), type: 'ls-alert-danger' })
    }
    return response
  })
}

export const regenerateOrder = (context, payload) => {
  return actions.changeDueDate(payload)
  .then((response) => {
    if (response && response.status === 200) {
      context.commit(addFlash, { message: t(context, 'contracts.alerts.email_successful'), type: 'ls-alert-success' })
    }
    return response
  })
}

export const loadInvoice = (context, payload) => {
  return actions.getInvoice(payload)
  .then((response) => {
    if (response && response.status === 200) {
      context.commit(types.setInvoice, response.data.invoice)
    }
    return response
  })
}

export const recoverOrCreateBillet = (context, payload) => {
  return actions.getBillet(payload)
  .then((response) => {
    return response
  })
}

export const updateCorpDueDateInvoice = (context, payload) => {
  return actions.updateCorpDueDateInvoice(payload)
  .then((response) => {
    if (response && response.status === 200) {
      context.commit(types.setInvoice, response.data.invoice)
      context.commit(addFlash, { message: t(context, 'invoices.alerts.successful_due_date_change'), type: 'ls-alert-success' })
    }
    return response
  })
}

export const confirmInvoice = (context, payload) => {
  return actions.confirmInvoice(payload)
  .then((response) => {
    if (response && response.status === 200) {
      context.commit(addFlash, { message: response.data.message, type: 'ls-alert-success' })
    } else {
      context.commit(addFlash, { message: response.data.message, type: 'ls-alert-danger' })
    }
    return response
  })
}

export const cancelInvoice = (context, payload) => {
  return actions.cancelInvoice(payload)
  .then((response) => {
    if (response && response.status === 200) {
      context.commit(addFlash, { message: response.data.message, type: 'ls-alert-success' })
    } else {
      context.commit(addFlash, { message: response.data.error.message, type: 'ls-alert-danger' })
    }
    return response
  })
}

export const reverseInvoice = (context, payload) => {
  return actions.reverseInvoice(payload)
  .then((response) => {
    if (response && response.status === 200) {
      context.commit(addFlash, { message: response.data.message, type: 'ls-alert-success' })
    } else {
      context.commit(addFlash, { message: response.data.error.message, type: 'ls-alert-danger' })
    }
  })
}

export const verifyOrders = (context, payload) => {
  return actions.verifyOrders(payload)
  .then((response) => {
    if (response && response.status === 200) {
      context.commit(addFlash, { message: response.data.message, type: 'ls-alert-success' })
    } else {
      context.commit(addFlash, { message: response.data.error.message, type: 'ls-alert-danger' })
    }
    return response
  })
}

export const createTaxInvoice = (context, payload) => {
  return actions.createTaxInvoice(payload)
    .then((response) => {
      if (response && response.status === 200) {
        context.commit(addFlash, { message: t(context, 'invoices.alerts.successful_nf_creation'), type: 'ls-alert-success' })
      } else {
      }
      return response
    })
}

export const cancelTaxInvoice = (context, payload) => {
  return actions.cancelTaxInvoice(payload)
    .then((response) => {
      if (response && response.status === 200) {
        context.commit(addFlash, { message: t(context, 'invoices.alerts.successful_nf_cancel'), type: 'ls-alert-success' })
      } else {
      }
      return response
    })
}

export const loadInvoiceById = (context, payload) => {
  return actions.getInvoiceById(payload)
  .then((response) => {
    if (response && response.status === 200) {
      context.commit(types.setInvoice, response.data.invoice)
    }
    return response
  })
}

export const consultServiceTaxInvoice = (context, payload) => {
  return actions.consultServiceTaxInvoice(payload)
    .then((response) => {
      if (response && response.status === 200) {
        return response
      } else {
        context.commit(addFlash, { message: t(context, 'invoices.alerts.nf_not_found'), type: 'ls-alert-danger' })
      }
      return response
    })
}

export const getCsvInvoices = (context, payload) => {
  return actions.getInvoicesCsv(payload).then(function (response) {
    if (response.data) {
      csv.download(response.data, t(context, 'invoices.formats.csv', {today: date.parseDefaultDate(new Date(), '-'), subdomain: window.location.host.split('.')[0]}))
      context.commit(addFlash, { message: t(context, 'invoices.alerts.report_generated'), type: 'ls-alert-success' })
    } else {
      if (response && response.status === 200) {
        context.commit(addFlash, { message: t(context, 'invoices.alerts.report_sent', {email: JSON.parse(window.localStorage.getItem('user')).email}),
          type: 'ls-alert-success' })
      }
      return response
    }
  })
}



// WEBPACK FOOTER //
// ./src/app/pages/invoices/vuex/actions.js